import type {ErrorMessage} from 'angular-error-repository';

import type {
    ContractDurationCompatibilityValidatorError as ValidatorError,
} from '../validator/contract-duration-compatibility.validator';

export const contractDurationCompatibilityError: ErrorMessage<ValidatorError> = () => {
    return `Error.Contract duration incompatible with selected products`;
};
